const MOBILE_MAX = 767 as const;

const mobile = `@media (max-width: ${MOBILE_MAX}px)` as const;
const desktop = `@media (min-width: ${MOBILE_MAX + 1}px)` as const;

export { MOBILE_MAX, mobile, desktop };
